import React, { useState, useEffect } from "react";
import {
  Paper,
  Box,
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Checkbox,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputLabel,
  Divider,
  CircularProgress,
  Autocomplete,
} from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";

import { makeStyles } from "@material-ui/styles";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import { dashboardStyle } from "../../Invoices/Components/InvoiceDetails/style";
import UsersByRole from "../../Invoices/NewInvoice/Dropdowns/UsersByRole";
import { getUsersByRole } from "../../Invoices/actions";
import { Backdrop } from "@material-ui/core";
import { getRefrenceDataList } from "../../Invoices/actions";
import CustomSnackbar from "../../../CustomSnackbar";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TabelSkeleton from "../../../StyledComponents/TableSkeleton";
import Tooltip from "@mui/material/Tooltip";
import EmptyData from "../../../StyledComponents/Table/EmptyData";

const useStyles = makeStyles(dashboardStyle);
function AdminSettings() {
  const classes = useStyles();
  const [openModel, setOpenModel] = useState(false);
  const [userloader, setUserLoader] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [error, seterror] = useState(false);
  const [togglebutton, settogglebutton] = useState(null);
  const [statusLoading, setStatusLoading] = useState(false);

  const [deleteId, setDeleteID] = useState("");
  const [userId, setUserID] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [getTaxUser, setgetTaxUser] = useState([]);
  const [getuserdata, setgetUserdata] = useState([]);
  const [searchApi, setSearchAPi] = useState([])

  const [formState, setFormState] = useState({
    taxTeam: "",
    invoice_Type: "",
  });
  const [multipleData, setMultipleData] = useState({
    invoice_Type: [],
  });
  const ITEM_HEIGHT = 40;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  // const [userData, setUserData] = useState([]);
  // const [loading, setLoading] = useState(false);
  const handleOpenModel = () => {
    setOpenModel(true);
  };

  const handleCloseModel = () => {
    setOpenModel(false);
    seterror(false)
  };
  const submitHandler = (e) => {
    e.preventDefault();
  };


  const getUserByLocation = (apiString) => {

    setStatusLoading(true);

    var axios = require("axios");

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/api/Role/GetUserList_v2/${apiString}`,
      // url:`https://i2p-sfg.genial365.com/api/Role/GetUserList_v2/tax%20team`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
    };

    axios(config)
      .then(function (response) {
        setgetUserdata(response.data);


        setStatusLoading(false);
      })
      .catch(function (error) { });
  }
  const create_user = () => {
    var axios = require("axios");
    var data = JSON.stringify({
      id: 0,
      invoice_Type: formState.invoice_Type,
      user_Id: formState.taxTeam,
      created_By: "string",
      created_On: null,
      updated_By: "string",
      updated_On: null,
    });
    seterror(false);
    if (formState?.invoice_Type === "" || formState?.taxTeam === "") {
      seterror(true);
    } else {
      setUserLoader(true);

      var config = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/api/InvoiceTypeWiseUser/PostInvoiceTypeWiseUser`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(config)
        .then(function (response) {
          //
          setFormState({
            taxTeam: "",
            invoice_Type: "",
          });
          get_TaxUser()
          setSuccessMessage(response.data);

          setUserLoader(false);
          setOpenModel(false);
        })
        .catch(function (error) {
          setUserLoader(false);

          // setErrorMessage(error.data);
          setErrorMessage(error.response.data);

          setUserLoader(false);
        });
    }
  };
  // update user 
  const update_user = () => {
    var axios = require("axios");
    var data = JSON.stringify({
      id: userId,
      invoice_Type: formState.invoice_Type,
      user_Id: formState.taxTeam,
      created_By: "string",
      created_On: null,
      updated_By: "string",
      updated_On: null,
    });
    setUserLoader(true);

    var config = {
      method: "put",
      url: `${process.env.REACT_APP_API_URL}/api/InvoiceTypeWiseUser/PutInvoiceTypeWiseUser`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {

        setFormState({
          taxTeam: "",
          invoice_Type: "",
        });
        setSuccessMessage(response.data);

        setUserLoader(false);
        setOpenModel(false);
        get_TaxUser();
      })
      .catch(function (error) {
        setUserLoader(false);

        setErrorMessage(error.message);
        // setErrorMessage(error.response.data.message);
        setUserLoader(false);
      });

  }
  // get All tax user
  const get_TaxUser = () => {
    setStatusLoading(true);

    var axios = require("axios");

    var config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/api/InvoiceTypeWiseUser/GetInvoiceTypeWiseUser`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
    };

    axios(config)
      .then(function (response) {
        setgetTaxUser(response.data);
        setSearchAPi(response.data)


        setStatusLoading(false);
      })
      .catch(function (error) { });
  };
  //  fetch by id 
  const fetch_data_by_id = (id) => {
    var axios = require("axios");

    var config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/api/InvoiceTypeWiseUser/GetInvoiceTypeWiseUserById/${id}`,
      headers: {
        Authorization: `bearer ${localStorage.getItem("user_token")}`,
      },
    };

    axios(config)
      .then(function (response) {





        // let a = response.data.map((item,i)=>{
        //       return({
        //         roleid:item.roleId
        //       }
        //       )
        // })
        //
        // setPersonRoles(a)
        //
      })

      .catch(function (error) { });
  };

  const delete_user = (id) => {
    var axios = require("axios");
    setUserLoader(true);
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/InvoiceTypeWiseUser/DeleteInvoiceTypeWiseUser/${id}`,
      headers: {
        Authorization: `bearer ${localStorage.getItem("user_token")}`,
      },
    };

    axios(config)
      .then(function (response) {
        //
        get_TaxUser();
        setOpenModel(false);
        setUserLoader(false);
        setSuccessMessage(response.data);
        setDeleteID("");
      })
      .catch(function (error) {
        setUserLoader(false);

        setErrorMessage(error.response.data);
      });
  };


  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };
  const handleSearchInput = (e) => {
    const inputValue = e.target.value;
    if (e.target.value === "") {
      setgetTaxUser(searchApi)
    } else {
      const fiterData = searchApi.filter((data =>
        data.userName
          .toLowerCase()
          .includes(inputValue.toLowerCase()) ||
        data.i.invoice_Type
          .toLowerCase()
          .includes(inputValue.toLowerCase())


      ))
      if (fiterData.length > 0) {
        setgetTaxUser(fiterData)

      } else {
        let msg = "No Records Found"
        setgetTaxUser([{ message: msg }])
      }
    }
  }
  useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => { },
      setMultipleData
    );
    get_TaxUser();
    getUserByLocation("Tax Team")
  }, []);


  return (
    <div>
      <Box display="flex" justifyContent={"end"}>
        <Button
          variant="contained"
          size={"small"}
          color="secondary"
          sx={{
            color: "#fff",
            fontSize: "15px",
            marginTop: "4px",
            width: "151px",
          }}
          onClick={() => {
            setDeleteID("");
            handleOpenModel();
            setFormState({
              taxTeam: "",
              invoice_Type: "",
            });
            settogglebutton(null)
          }}
        >
          {/* <AddIcon /> */}
          Add Tax User
        </Button>
      </Box>
      <Card style={{ marginTop: "24px" }}>
        <CardHeader color="primary" text>
          <CardText color="primary" style={{ padding: "0px 27px" }}>
            {/* <Box> */}
            <h4>Add/Edit Tax User</h4>

            {/* </Box> */}
          </CardText>
        </CardHeader>
        <CardBody>
          <Grid container spacing={2} pb={3}>
            <Grid item md={4} sx={3} mt={2} ml={1}>
              <TextField
                size="small"
                sx={{
                  "& .MuiInputBase-root": {
                    height: 30,
                  }
                }}
                fullWidth
                id="outlined-basic"
                placeholder="Search here...."
                variant="outlined"
                // value={searchInput}
                type="search"

                onChange={(e) => {
                  handleSearchInput(e)
                  setSearchInput(e.target.value)
                }}
              />
            </Grid>
          </Grid>
          <TableContainer className="scrollable"

            sx={{
              height: 400
            }}
          >

            <Table
              className={classes.table}
              aria-label="a dense table"
              style={{ padding: "0px 27px" }}
              // padding="normal"
              size="small"
              sx={{
                height: "max-content"
              }}
            >
              <TableHead
                style={{
                  position: 'sticky',
                  top: '0px',
                }}>
                <TableRow sx={{ backgroundColor: "#A5ACB0" }}>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#fff", width: 200 }}
                  >
                    SR#
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                    User Name
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                    Invoice Type
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{ fontWeight: "bold", color: "#fff" }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody >
                {getTaxUser.map((item, index) => {
                  return (
                    <>

                      {item.message ? (
                        <>

                          <TableRow
                          // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                          >
                            <TableCell colSpan={4}
                              style={{

                                border: "none",
                                textAlign: "center",
                                padding: "20px 10px 20px",

                              }}
                            >
                              <Typography>No Records Found</Typography>

                            </TableCell>

                          </TableRow>
                        </>

                      ) : (
                        <TableRow
                          key={1}
                        // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                        >
                          <TableCell scope="row">{index + 1}</TableCell>
                          <TableCell>{
                            item.userName

                          }</TableCell>
                          <TableCell>{item.i.invoice_Type}</TableCell>

                          <TableCell align="right">
                            <Tooltip title="Edit">
                              <EditIcon
                                color="success"
                                sx={{ "&:hover": { cursor: "pointer" } }}
                                onClick={() => {
                                  setDeleteID("");
                                  setUserID(item.i.id)
                                  settogglebutton(1);
                                  setFormState((formState) => ({
                                    ...formState,
                                    taxTeam: item.i.user_Id,
                                    invoice_Type: item.i.invoice_Type


                                  }))
                                  fetch_data_by_id(item.i.id)
                                  handleOpenModel();
                                }}
                              />
                            </Tooltip>
                            <Tooltip title="Delete">
                              <DeleteIcon
                                color="error"
                                sx={{ "&:hover": { cursor: "pointer" } }}
                                onClick={() => {
                                  setDeleteID(item.i.id);
                                  settogglebutton(null);
                                  handleOpenModel();
                                }}
                              />
                            </Tooltip>


                          </TableCell>
                        </TableRow>

                      )}

                    </>
                  );
                })}
              </TableBody>
              {statusLoading && <TabelSkeleton noOfColumns={4} noOfLines={3} />}
            </Table>
            {getTaxUser?.length === 0 && !statusLoading ? <EmptyData /> : ""}
          </TableContainer>
        </CardBody>
      </Card>
      <form onSubmit={(e) => submitHandler(e)}>
        <Dialog open={openModel} onClose={handleCloseModel} fullWidth>
          {deleteId ? (
            <>
              <DialogContent>
                <Backdrop
                  sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={userloader}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <HelpOutline color="secondary" fontSize="large" mt={2} />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                  p={2}
                  mt={1}
                >
                  <Typography variant="h4" style={{ width: "80%" }}>
                    Are you sure you want to Delete a User?
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                  m={1}
                >
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleCloseModel}
                  >
                    NO
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    style={{ marginLeft: "20px" }}
                    onClick={() => {
                      delete_user(deleteId);
                    }}
                  >
                    Yes
                  </Button>
                </Box>
              </DialogContent>
            </>
          ) : (
            <>
              <DialogTitle
                sx={{
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              >
                {togglebutton ? "Update Tax Team User" : "Create Tax Team User"}
              </DialogTitle>
              <Divider />
              <DialogContent>
                <Backdrop
                  sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={userloader}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>

                <Grid container spacing={2} pb={3}>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth size="small">
                      <UsersByRole
                        label="Tax Team"
                        apiString="Tax Team"
                        name="taxTeam"
                        formState={formState}
                        changeHandler={changeHandler}
                        classes={classes}
                      />
                      {/*<Typography>
                Tax Team
                <span className={classes.asterisk}>*</span>
              </Typography>
              <Select
                labelId="demo-simple-name-label"
                id="demo-simple-name"
                name="taxTeam"
                displayEmpty
                value={formState.taxTeam}
                className={classes.selectEmpty}
                onChange={changeHandler}
                inputProps={{ "aria-label": "Without label" }}
                //  MenuProps={MenuProps}
                //  InputLabelProps={{ shrink: false, required: false, className: classes.hs_form_required }}
                // select
                // fullWidth
                // size="small"
              >
              <MenuItem value="">
              Select a  Value
               </MenuItem>
                {!statusLoading ? (
                  getuserdata.length > 0 ? (
                    getuserdata.map((item, index) => (
                      <MenuItem key={index} value={item.userId}>
                        {item.userName}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>Not Found</MenuItem>
                  )
                ) : (
                  <MenuItem>
                    <CircularProgress size={24} />
                  </MenuItem>
                )}
                </Select>
              */}


                      {error && formState.taxTeam == "" ? (
                        <>
                          <Typography
                            variant="h6"
                            component="h6"
                            color="error"
                            ml={1}
                          >
                            tax team is required
                          </Typography>
                        </>
                      ) : null}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth size="small">
                      <Typography>
                        Invoice Type
                        <span className={classes.asterisk}>*</span>
                      </Typography>

                      <Select
                        id="submitter_role"
                        size="small"
                        name="invoice_Type"
                        variant="outlined"
                        displayEmpty
                        value={formState.invoice_Type}
                        // loading={rolesLoading}
                        disablePortal
                        label={formState?.invoice_Type === "" ? "Select a  value" : ""}
                        InputLabelProps={{ shrink: false, required: false, className: classes.hs_form_required }}
                        onChange={changeHandler}
                        MenuProps={MenuProps}
                      >
                        <MenuItem value="" disabled>
                          Select a value
                        </MenuItem>
                        {multipleData?.invoice_Type
                          .filter((item) => {
                            return item.ReferenceProp2 !== "HR";
                          })
                          .map((item, index) => (
                            <MenuItem key={index} value={item.ReferenceCode}>
                              {item.ReferenceCode}
                            </MenuItem>
                          ))}
                      </Select>
                      {error && formState.invoice_Type == "" ? (
                        <>
                          <Typography
                            variant="h6"
                            component="h6"
                            color="error"
                            ml={1}
                          >
                            invoice type is required
                          </Typography>
                        </>
                      ) : null}

                    </FormControl>
                  </Grid>
                </Grid>
              </DialogContent>
              <Divider />

              <DialogActions>
                <Button variant="outlined" color="error" onClick={handleCloseModel}>
                  Cancel
                </Button>
                {togglebutton ? (
                  <Button
                    color="success"
                    variant="contained"
                    onClick={() => {
                      update_user(userId);
                    }}
                  >
                    Updated
                  </Button>
                ) : (<Button
                  color="secondary"
                  variant="contained"
                  type="submit"
                  onClick={create_user}
                >
                  Save
                </Button>)}

              </DialogActions>
            </>)}

        </Dialog>
      </form>
      {successMessage && (
        <CustomSnackbar
          open={true}
          message={successMessage}
          handleClose={() => setSuccessMessage("")}
          variant="success"
        />
      )}
      {errorMessage && (
        <CustomSnackbar
          open={errorMessage !== ""}
          message={errorMessage}
          handleClose={() => setErrorMessage("")}
          variant="error"
        />
      )}
    </div>
  );
}
export default AdminSettings;
